import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { Plus } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface CloneConfirmModalProps {
    event: any;
    date: Date;
    onClose: () => void;
    onConfirm: () => void;
    isSaving: boolean;
}

export const CloneConfirmModal: React.FC<CloneConfirmModalProps> = ({ 
    event, date, onClose, onConfirm, isSaving 
}) => (
    <ModalWrapper onClose={onClose} borderColor="#f29b11">
        <Plus size={48} color="#f29b11" style={{ margin: '0 auto 20px' }} />
        <h2 style={{ ...UI.text.title, fontSize: 18, marginBottom: 10 }}>Plan Event?</h2>
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>
            Create a copy of <strong style={{ color: '#fff' }}>{event.label}</strong> for <br/> 
            <strong style={{ color: '#f29b11' }}>{date.toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' }).toUpperCase()}</strong>?
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button className="premium-btn-primary" style={{ ...UI.button.primary, backgroundColor: "#f29b11", color: "#000", borderColor: "transparent" }} onClick={onConfirm} disabled={isSaving}>{isSaving ? 'PLANNING...' : 'CONFIRM & PLAN'}</button>
            <button className="premium-btn-secondary" onClick={onClose}>CANCEL</button>
        </div>
    </ModalWrapper>
);
